import {Component, computed, inject, input, Signal} from '@angular/core';
import {InstantsearchHierarchicalMenuComponent} from '../../instantsearch-hierarchical-menu.component';
import {HierarchicalMenuItem} from 'instantsearch.js/es/connectors/hierarchical-menu/connectHierarchicalMenu';
import {RefinementListItem} from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import {UrlNameService} from '@core/services/url-name.service';
import {RouterModule} from '@angular/router';
import {
  InstantsearchRefinementListComponent
} from '../../../../../../instantsearch/instantsearch-refinement-list/instantsearch-refinement-list.component';
import {RouterContextDirective} from '@core/directives/router-context.directive';
import {StoreConfigService} from '@core/services/store-config.service';
import {ALGOLIA_SEPERATOR} from '@core/services/algolia.service';
import {defaultSortBy} from '@core/instantsearch/components/instantsearch-base-refinement-list.component';

@Component({
  selector: 'app-instantsearch-hierarchical-menu-last',
  templateUrl: './instantsearch-hierarchical-menu-last.component.html',
  styleUrls: ['./instantsearch-hierarchical-menu-last.component.scss'],
  imports: [RouterModule, InstantsearchRefinementListComponent, RouterContextDirective]
})
export class InstantsearchHierarchicalMenuLastComponent {
  instantsearchHierarchicalMenu = inject(InstantsearchHierarchicalMenuComponent);
  urlNameService = inject(UrlNameService);
  storeConfigService = inject(StoreConfigService);

  path = input<string | null>(null);

  sortBy = defaultSortBy;

  districtSortBy(a: any, b: any) {
    const sortByLast = 'sort_by_last';
    const separator = ALGOLIA_SEPERATOR;

    const [, aLabel, aSortBy] = (a.label ?? a.name)?.split(separator);
    const [, bLabel, bSortBy] = (b.label ?? b.name)?.split(separator);

    if (aSortBy === sortByLast) return 1;
    if (bSortBy === sortByLast) return -1;

    if (b.count !== a.count) return b.count - a.count;

    return aLabel.localeCompare(bLabel);
  }

  districtTransformItems = (items: RefinementListItem[]) => {
    const sortByLast = 'sort_by_last';
    const hasNonOevrige = items.some(item => {
      const parts = item.label?.split(ALGOLIA_SEPERATOR);
      return parts?.[2] !== sortByLast;
    });
    if (!hasNonOevrige) {
      return [];
    }
    return this.instantsearchHierarchicalMenu.transformValue(items);
  };

  get activeLvl0Item(): Signal<HierarchicalMenuItem | undefined> {
    return this.instantsearchHierarchicalMenu.activeLvl0Item;
  }

  get activeLvl1Item(): Signal<HierarchicalMenuItem> {
    return this.instantsearchHierarchicalMenu.activeLvl1Item;
  }

  get activeLvl2Item(): Signal<HierarchicalMenuItem> {
    return this.instantsearchHierarchicalMenu.activeLvl2Item;
  }

  get activeMenuItem() {
    return computed(() => this.activeLvl2Item().isRefined ? this.activeLvl2Item() : this.activeLvl1Item());
  }

  get transformValue() {
    return this.instantsearchHierarchicalMenu.transformValue;
  }

  join(parts: string[], separator: string) {
    return parts.filter(part => part).join(separator);
  }

  getUrlName(nonFriendlyUrl: string) {
    return this.urlNameService.getFriendlyUrl(nonFriendlyUrl) ?? '';
  }

  getItemLabel(item: any) {
    return this.instantsearchHierarchicalMenu.getItemLabel(item);
  }
  getItemSearchParams(item: any) {
    return this.instantsearchHierarchicalMenu.getItemSearchParams(item);
  }
  getItemPathname(item: any) {
    return this.instantsearchHierarchicalMenu.getItemPathname(item);
  }

  getAdditionalContext(item: any, eventSourceName: string) {
    const separator = this.instantsearchHierarchicalMenu.separator();
    const menu_navigation_path = this.path() + separator + item.label;
    return {
      menu_navigation_path,
      eventSourceName
    }
  }

  getRefinementItemParams(itemLabel: string, itemParamName: string) {
    const activeParams = this.instantsearchHierarchicalMenu.getItemSearchParams(this.activeMenuItem());
    const defaultIndex = this.storeConfigService.storeConfig()?.algoliaDefaultIndex;
    activeParams[defaultIndex + '[refinementList][' + itemParamName + '][0]'] = itemLabel;
    return activeParams;
  }
}
